import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
const getRedtailState = (state: RootState) => state.redtail;

export const selectIsConnectingToRedtail = createSelector(
  [getRedtailState],
  ({ isConnectingToRedtail }) => isConnectingToRedtail
);

